export default class API {
  static History = class {
    static Data = class {
      static GET = (latitude, longitude) =>
        `https://p1l4gt4ufg.execute-api.ap-southeast-1.amazonaws.com/v2/web/location/history?latitude=${latitude}&longitude=${longitude}`;
    };
  };
}
